import React, { useState, useEffect } from "react";
import { Container, Grid, Typography, Card, CardContent } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import CardMedia from "@mui/material/CardMedia";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";

const HomePage = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [regionalNetworkOption, setRegionalNetworkOption] = useState(null);
  // const [countryOption, setcountryOption] = useState(null);
  // const [memberStateOption, setmemberStateOption] = useState(null);
  const [content, setContent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));
    if (!userData) {
      console.error("User data not found. Redirecting to login.");
      return;
    }
    setSelectedOption(userData.selectedOption);
    setRegionalNetworkOption(userData.regionalNetworkOption);
    // setcountryOption(userData.countryOption);
    // setmemberStateOption(userData.memberStateOption);

    if (userData) {
      switch (userData.selectedOption) {
        case "Comesa":
          setContent(
            <Grid item xs={12} sx={{ marginTop: "20px" }}>
              <img
                src="./l1.jpg"
                alt="COMESA Logo"
                style={{ maxWidth: "200px" }}
              />
              <Typography variant="h3" gutterBottom>
                EA-SA-IO ICT PORTAL
              </Typography>
              <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                Streamline your project management, data collection, reporting,
                and risk management processes within the EA-SA-IO ICT PORTAL.
              </Typography>
            </Grid>
          );
          break;

        case "Regional Network":
          if (userData.regionalNetworkOption === "COMESA") {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <img
                  src="./COMESA.webp"
                  alt="Regional Portal"
                  style={{ maxWidth: "200px" }}
                />
                <Typography variant="h3" gutterBottom>
                  COMESA Region
                </Typography>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                  Welcome to the COMESA Region, where you can access resources
                  and information tailored to regional initiatives and
                  collaborations.
                </Typography>
              </Grid>
            );
          } else if (userData.regionalNetworkOption === "EAC") {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <img
                  src="./EAC.webp"
                  alt="EAC Regional Portal"
                  style={{ maxWidth: "200px" }}
                />
                <Typography variant="h3" gutterBottom>
                  EAC Region
                </Typography>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                Welcome to the EAC Region, where you can access resources
                  and information tailored to regional initiatives and
                  collaborations.


                </Typography>
              </Grid>
            );
          } else if (userData.regionalNetworkOption === "IGAD") {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <img
                  src="./IGAD.webp"
                  alt="IGAD Regional Portal"
                  style={{ maxWidth: "200px" }}
                />
                <Typography variant="h3" gutterBottom>
                  IGAD Region
                </Typography>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                Welcome to the IGAD Region, where you can access resources
                  and information tailored to regional initiatives and
                  collaborations.
                </Typography>
              </Grid>
            );
          } else if (userData.regionalNetworkOption === "SADC") {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <img
                  src="./SADC.webp"
                  alt="SADC Regional Portal"
                  style={{ maxWidth: "200px" }}
                />
                <Typography variant="h3" gutterBottom>
                  SADC Region
                </Typography>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                Welcome to the SADC Region, where you can access resources
                  and information tailored to regional initiatives and
                  collaborations.
                </Typography>
              </Grid>
            );
          } else if (userData.regionalNetworkOption === "IOC") {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <img
                  src="./IOC.webp"
                  alt="IOC Regional Portal"
                  style={{ maxWidth: "200px" }}
                />
                <Typography variant="h3" gutterBottom>
                  IOC Region
                </Typography>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                Welcome to the IOC Region, where you can access resources
                  and information tailored to regional initiatives and
                  collaborations.
                </Typography>
              </Grid>
            );
          } else {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                  You do not belong to a recognized regional network.
                </Typography>
              </Grid>
            );
          }
          break;

        case "Member State":
          if (userData.memberStateOption === "COMESA") {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <img
                  src="./COMESA.webp"
                  alt="Regional Portal"
                  style={{ maxWidth: "200px" }}
                />
                <Typography variant="h3" gutterBottom>
                  {/* {userData.memberStateOption} Region */}
                 {userData.countryOption}
                </Typography>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                  Welcome to the {userData.countryOption}, where you
                  can access resources and information tailored to regional
                  initiatives and collaborations.
                </Typography>
              </Grid>
            );
          } else if (userData.memberStateOption === "EAC") {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <img
                  src="./EAC.webp"
                  alt="EAC Regional Portal"
                  style={{ maxWidth: "200px" }}
                />
                <Typography variant="h3" gutterBottom>
                  {/* {userData.memberStateOption} Region */}
                  {userData.countryOption}
                </Typography>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                Welcome to the {userData.countryOption}, where you
                  can access resources and information tailored to regional
                  initiatives and collaborations.
                </Typography>
              </Grid>
            );
          } else if (userData.memberStateOption === "IGAD") {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <img
                  src="./IGAD.webp"
                  alt="IGAD Regional Portal"
                  style={{ maxWidth: "200px" }}
                />
                <Typography variant="h3" gutterBottom>
                  {/* {userData.memberStateOption} Region */}
                 {userData.countryOption}
                </Typography>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                Welcome to the {userData.countryOption}, where you
                  can access resources and information tailored to regional
                  initiatives and collaborations.
                </Typography>
              </Grid>
            );
          } else if (userData.memberStateOption === "SADC") {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <img
                  src="./SADC.webp"
                  alt="SADC Regional Portal"
                  style={{ maxWidth: "200px" }}
                />
                <Typography variant="h3" gutterBottom>
                  {/* {userData.memberStateOption} Region */}
                  {userData.countryOption}
                </Typography>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                Welcome to the {userData.countryOption}, where you
                  can access resources and information tailored to regional
                  initiatives and collaborations.
                </Typography>
              </Grid>
            );
          } else if (userData.memberStateOption === "IOC") {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <img
                  src="./IOC.webp"
                  alt="IOC Regional Portal"
                  style={{ maxWidth: "200px" }}
                />
                <Typography variant="h3" gutterBottom>
                  {/* {userData.memberStateOption} Region */}
                {userData.countryOption}
                </Typography>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                Welcome to the {userData.countryOption}, where you
                  can access resources and information tailored to regional
                  initiatives and collaborations.
                </Typography>
              </Grid>
            );
          } else {
            setContent(
              <Grid item xs={12} sx={{ marginTop: "20px" }}>
                <Typography variant="h6" paragraph sx={{ margin: "2px" }}>
                  You do not belong to a recognized regional network.
                </Typography>
              </Grid>
            );
          }

          break;

        default:
          setContent(null);
          break;
      }
    } else {
      let accessToken = document.cookie
        .split("; ")
        .find((row) => row.startsWith("accessToken="));
      accessToken = accessToken || localStorage.getItem("accessToken");

      if (accessToken) {
        navigate("/home");
      }
    }
  }, [navigate, regionalNetworkOption]);

  // Add Elfsight script loader
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container
      maxWidth="lg"
      sx={{ marginTop: "2px", textAlign: "center", paddingLeft: "0px" }}
    >
      {/* Add Elfsight widget container */}
      <div className="elfsight-app-f11063c8-6f6e-41a2-b858-6fd2bcd4bff3"></div>
      
      <div>
        {content}

        <div sx={{ marginAll: "auto" }}>
          <Grid
            container
            spacing={4}
            sx={{ marginTop: "2px", justifyContent: "center" }}
          >
            {selectedOption !== "Comesa" && (
              <>
                <Grid item xs={12} sm={6} md={3}>
                  <Card sx={{ maxWidth: 345 }}>
                    <CardActionArea component={Link} to="/dashboard">
                      <CardMedia
                        component="img"
                        height="80"
                        image="./projectManagement.jpeg"
                        alt="Project Management"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          Project Management
                        </Typography>
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          The Project Management module enables users to create,
                          update, and track projects, ensuring efficient project
                          oversight.
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      <Button size="small" color="primary" component={Link} to="/dashboard">
                        Open
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Card sx={{ maxWidth: 345 }}>
                    <CardActionArea component={Link} to="/Data-Collection">
                      <CardMedia
                        component="img"
                        height="80"
                        image="./DataCollection.jpeg"
                        alt="Data Collection"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          Data Collection
                        </Typography>
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          The Data Collection module allows users to capture and
                          manage data on outcomes, outputs, and activities
                          efficiently.
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      <Button size="small" color="primary" component={Link} to="/Data-Collection">
                        Open
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <Card sx={{ maxWidth: 345 }}>
                    <CardActionArea component={Link} to="/risk-management">
                      <CardMedia
                        component="img"
                        height="80"
                        image="./RiskManagement.jpeg"
                        alt="Risk Management"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          Risk Management
                        </Typography>
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          The Risk Management module enables users to identify,
                          assess, and mitigate project risks for better outcomes.
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      <Button size="small" color="primary" component={Link} to="/risk-management">
                        Open
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              </>
            )}

            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ maxWidth: 345 }}>
                <CardActionArea component={Link} to="/Reporting">
                  <CardMedia
                    component="img"
                    height="80"
                    image="./Reporting.jpeg"
                    alt="Reporting"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Reporting
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      The Reporting module generates comprehensive reports,
                      providing insights into project performance and
                      facilitating informed decisions.
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    component={Link}
                    to="/Reporting"
                  >
                    Open
                  </Button>
                </CardActions>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ maxWidth: 345 }}>
                <CardActionArea component={Link} to="/stakeholdermanagement">
                  <CardMedia
                    component="img"
                    height="80"
                    image="./stekeholder.jpeg"
                    alt="Stekeholder"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Stakeholder management
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      Stakeholder management identifies and engages those
                      affected by a project.
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    component={Link}
                    to="/stakeholdermanagement"
                  >
                    Open
                  </Button>
                </CardActions>
              </Card>
            </Grid>

            {selectedOption === "Comesa" && (
              <Grid item xs={12} sm={6} md={3}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardActionArea component={Link} to="/usermanagement">
                    <CardMedia
                      component="img"
                      height="110"
                      image="./usermanagement.jpeg"
                      alt="usermanagement"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        user management
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary" }}
                      >
                        User management involves user registration,
                        authentication, roles, permissions, and profiles.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button
                      size="small"
                      color="primary"
                      component={Link}
                      to="/usermanagement"
                    >
                      Open
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            )}

            {/* <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ maxWidth: 345 }}>
                <CardActionArea component={Link} to="/m&e">
                  <CardMedia
                    component="img"
                    height="110"
                    image="./M&E.webp"
                    alt="usermanagement"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                    M&E Module
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    The M&E Module tracks project outcomes, outputs, and activities for performance evaluation.
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button size="small" color="primary" component={Link} to="/m&e">Open</Button>
                </CardActions>
              </Card>
            </Grid> */}

            {selectedOption !== "Comesa" && (
              <Grid item xs={12} sm={6} md={3}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardActionArea component={Link} to="/ictn">
                    <CardMedia
                      component="img"
                      height="110"
                      image="./ict.jpeg"
                      alt="usermanagement"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        ICT News and Events
                      </Typography>
                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        Stay updated on the latest ICT news, workshops,
                        conferences, and events.
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button size="small" color="primary" component={Link} to="/ictn">
                      Open
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ maxWidth: 345 }}>
                <CardActionArea component={Link} to="/budget">
                  <CardMedia
                    component="img"
                    height="110"
                    image="./Budget.jpeg"
                    alt="Budget"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Budget
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      Plan of income and expenses, guiding financial decisions
                      and resource allocation.
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    component={Link}
                    to="/budget"
                  >
                    Open
                  </Button>
                </CardActions>
              </Card>
            </Grid>


            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ maxWidth: 345 }}>
                <CardActionArea component={Link} to="/ict-statistics">
                  <CardMedia
                    component="img"
                    height="110"
                    image="./ict_stat.jpg"
                    alt="Budget"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      ICT Statistics
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                    Regional integration enhances ICT growth, promoting climate-conscious, financial sustainability.
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    component={Link}
                    to="/ict-statistics"
                  >
                    Open
                  </Button>
                </CardActions>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ maxWidth: 345 }}>
                <CardActionArea component={Link} to="/reminder">
                  <CardMedia
                    component="img"
                    height="130"
                    image="./reminder.png"
                    alt="Budget"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Reminder
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      A reminder helps keep important tasks and events in focus.
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    component={Link}
                    to="/reminder"
                  >
                    Open
                  </Button>
                </CardActions>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{ maxWidth: 345 }}>
                <CardActionArea component={Link} to="/documentation">
                  <CardMedia
                    component="img"
                    height="100"
                    image="./Doc.jpeg"
                    alt="Budget"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      Documentation & Training
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      documentation and training for users
                    </Typography>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <Button
                    size="small"
                    color="primary"
                    component={Link}
                    to="/documentation"
                  >
                    Open
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </div>
      </div>
    </Container>
  );
};

export default HomePage;
